export const MonthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const DaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const WeekdayMonthOffsets = [0, 3, 2, 5, 0, 3, 5, 1, 4, 6, 2, 4];

function isLeapYear(year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

export function getDaysInMonth(year, monthIndex) {
  return monthIndex === 1 && isLeapYear(year) ? 29 : DaysInMonth[monthIndex];
}

export function getFirstWeekdayOfMonth(year, monthIndex) {
  const adjustedYear = monthIndex < 2 ? year - 1 : year;
  const leapDays = Math.floor(adjustedYear / 4) - Math.floor(adjustedYear / 100) + Math.floor(adjustedYear / 400);
  return (adjustedYear + leapDays + WeekdayMonthOffsets[monthIndex] + 1) % 7;
}

export function toIsoDate(year, monthIndex, day) {
  return `${year}-${String(monthIndex + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function parseIsoDate(isoDate) {
  if (!isoDate) return null;
  const [year, month, day] = isoDate.split('-').map(Number);
  return { year, monthIndex: month - 1, day };
}

export function formatDisplayDate(isoDate) {
  const parsedDate = parseIsoDate(isoDate);
  return parsedDate ? `${MonthNames[parsedDate.monthIndex]} ${parsedDate.day}, ${parsedDate.year}` : '';
}

export function getTodayIsoDate() {
  const today = new Date();
  return toIsoDate(today.getFullYear(), today.getMonth(), today.getDate());
}